import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { TransactionPurposeEnum } from '../../enums/wallet.enum';
import { ITransactionInV2, IWalletInV2, IWalletV2 } from '../../interfaces/wallet.interface';
import { CustomPricingPipe } from '../../pipes';
import { formatDateDDMMYYYY } from '../../utils/date.utils';

@Injectable({
    providedIn: 'root',
})
export class WalletMapper {
    constructor(private translate: TranslateService, private pricingPipe: CustomPricingPipe) {}

    public fromIWalletDTOToWalletV2(wallet: IWalletInV2): IWalletV2 {
        return {
            ...wallet,
            transactions: wallet.transactions.map((transaction: ITransactionInV2) => ({
                ...transaction,
                date: new Date(transaction.date),
                event_date: new Date(transaction.event_date),
                title: this.generateTransactionTitle(transaction),
                purpose: transaction.purpose === TransactionPurposeEnum.USER ? null : transaction.purpose,
            })),
        };
    }

    private generateTransactionTitle(transaction: ITransactionInV2): string {
        if (!transaction) {
            return null;
        }
        let title: string = '';
        // sujet
        if (transaction.purpose) {
            if (transaction.purpose === TransactionPurposeEnum.HOMEWORK) {
                title += this.translate.instant('ENUM.TRANSACTION-PURPOSE.BOOKHOMEWORK');
            }
            if (transaction.purpose === TransactionPurposeEnum.MEAL) {
                title += this.translate.instant('ENUM.TRANSACTION-PURPOSE.BOOKMEAL');
            }
            if (transaction.purpose === TransactionPurposeEnum.NURSERY) {
                title += this.translate.instant('ENUM.TRANSACTION-PURPOSE.POINTING');
            }
        }

        // Si jamais on rechange d'avis ...
        // supprimé car les commentaires sont maintenant obligatoires (et affichés)
        // et donc on sait la raison de la decharge/paiement

        // if (
        //     transaction.type === TransactionTypeEnumV2.DEBIT &&
        //     (!transaction.purpose || transaction.purpose === TransactionPurposeEnum.USER)
        // ) {
        //     if (transaction.debit_type_id === 3) {
        //         title += this.translate.instant('ENUM.DEBIT-TYPES.UNLOAD_CLASS');
        //     }
        //     if (transaction.debit_type_id === 2) {
        //         title += this.translate.instant('ENUM.DEBIT-TYPES.UNLOAD');
        //     }
        //     if (transaction.debit_type_id === 1) {
        //         title += this.translate.instant('ENUM.DEBIT-TYPES.PAYMENT');
        //     }
        // }

        if (
            (!transaction.purpose || transaction.purpose === TransactionPurposeEnum.USER) &&
            transaction.debit_type_id &&
            transaction.comment?.length > 0
        ) {
            title += title.length === 0 ? transaction.comment : ' - ' + transaction.comment;
        }
        if (!transaction.purpose && !transaction.debit_type_id && (transaction.comment?.length <= 0 || !transaction.comment)) {
            title += this.translate.instant('SHOP.WALLET.NO_COMMENT');
        }
        //date
        title +=
            ' - ' +
            (transaction.event_date
                ? formatDateDDMMYYYY(new Date(transaction.event_date), '/')
                : formatDateDDMMYYYY(new Date(transaction.date), '/'));
        //student
        if (transaction.student.firstname) {
            title += ' - ' + transaction.student.firstname + ' ' + transaction.student?.lastname;
        }
        //prix
        title += ' - ' + this.pricingPipe.transform(transaction.amount, true);
        return title;
    }

    private dateSplitter(date?: Date): Date {
        if (date) {
            const splittedString: string[] = date.toString().split(/\D/);

            return new Date(+splittedString[2], +splittedString[1] - 1, +splittedString[0]);
        }
        return undefined;
    }
}
